import { render, staticRenderFns } from "./ac-compose-message.vue?vue&type=template&id=6731724c&"
import script from "./ac-compose-message.vue?vue&type=script&lang=js&"
export * from "./ac-compose-message.vue?vue&type=script&lang=js&"
import style0 from "./ac-compose-message.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports